var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8125 22.5197L2.5625 18.6657V6.33301L11.8125 2.47904V22.5197ZM1.19813 20.6019C0.917304 20.4848 0.677427 20.2872 0.508709 20.034C0.33999 19.7808 0.249975 19.4833 0.25 19.179V5.81966C0.249975 5.5154 0.33999 5.21793 0.508709 4.96473C0.677427 4.71153 0.917304 4.51391 1.19813 4.39677L10.923 0.343941C11.2744 0.19748 11.6566 0.140069 12.0356 0.176804C12.4146 0.21354 12.7787 0.343286 13.0955 0.554522C13.4123 0.765758 13.672 1.05195 13.8516 1.38768C14.0312 1.72341 14.1251 2.09829 14.125 2.47904V3.24983H16.0521C17.5413 3.24983 18.75 4.45689 18.75 5.94761V19.0511C18.75 19.7666 18.4658 20.4528 17.9598 20.9587C17.4538 21.4646 16.7676 21.7489 16.0521 21.7489H14.125V22.5197C14.1251 22.9004 14.0312 23.2753 13.8516 23.611C13.672 23.9468 13.4123 24.2329 13.0955 24.4442C12.7787 24.6554 12.4146 24.7852 12.0356 24.8219C11.6566 24.8586 11.2744 24.8012 10.923 24.6548L1.19813 20.6019ZM14.125 19.4365H16.0521C16.1543 19.4365 16.2523 19.3959 16.3246 19.3236C16.3969 19.2513 16.4375 19.1533 16.4375 19.0511V5.94761C16.4375 5.84539 16.3969 5.74737 16.3246 5.67509C16.2523 5.60282 16.1543 5.56221 16.0521 5.56221H14.125V19.4365Z",
    fill: "#600AAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeUp);
export default __webpack_public_path__ + "static/media/homeUp.36762c675d522fa93bfa262b9f188924.svg";
export { ForwardRef as ReactComponent };